import axios from 'axios';
import { ConfigService, StorageService } from './';
import store from '../store';
import { authType } from '../actions/type';

let abortRequestController;
/*Request Sample

_axiosData = {
  method : 'get', // get || post || put
  url: 'admin/rarities', // Only endpoint
  isAuthorized : true, // true or false
  isMultipart : true, // true or false
  allowRequestCancellation : true, // true or false
  params : {
    perPage: _perPage || 10,
    page: _page || 1,
    searchData: _searchData,
    isAll: _isAll
  },
  formData: // Only in case of post and put request
}
*/
const hit = async (_request) => {
  const apiBaseUrl = ConfigService.apiBaseUrl();
  try {
    let response = {};
    let _url = _request.externalUrl ? _request.url : apiBaseUrl + _request.url;
    let _authToken = null;

    if (_request.formData?.token) {
      _authToken = 'Bearer ' + _request.formData.token;
    } else {
      _authToken = ConfigService.authorizationToken();
    }

    let _config = {
      headers: {
        'content-type': _request.isMultipart
          ? 'multipart/form-data'
          : _request.externalContentType
            ? _request.externalContentType
            : 'application/json',
        Authorization: _request.isAuthorized ? _authToken : null,
      },
    };

    if (_request.params) {
      _config['params'] = _request.params;
    }

    // abort request
    if (_request.allowRequestCancellation) {
      if (abortRequestController) {
        abortRequestController.abort();
      }

      abortRequestController = new AbortController();

      _config['signal'] = abortRequestController.signal;
    }

    if (_request.method === 'get') {
      response = await axios.get(_url, _config);
    } else {
      response = await axios[_request.method](_url, _request.formData, _config);
    }
    return response;
  } catch (error) {
    if (error?.response?.headers['x-key'] === undefined) {
      throw new Error(
        'Service temporarily unavailable, please try again later or contact support',
      );
    }
    if (error.code === 'ERR_NETWORK') {
      throw new Error(
        'Unable to process your request, please try again later.',
      );
    } else if (error.response.status === 500) {
      throw new Error(error.response.data.message);
    } else if (error.response.status === 401) {
      // unauthorized access then logout the user
      StorageService.purgeData('authUser');
      store.dispatch({
        type: authType.LOGOUT,
      });
      throw new Error(error.response.data.message);
    }
    throw new Error(error.message);
  }
};

export { hit };
